module.exports = __webpack_public_path__ + "img/spicecurry.oourahanten.5ab70c61.jpg";